import { mapWaiseHttpMutationToCommand } from '../shared/waiseCommandRoutes';
import { waiseRevisionResource } from '../shared/waiseRevisionResource';
import { supportsWaiseCommand } from '../shared/waiseCommandSupport';
import { createDraftClientLineId } from './draftCartLines';
const snapshots = new WeakMap();
let capabilities = [];
export function bindWaiseSnapshot(data, revisions, nextCapabilities = capabilities) {
  const snapshot = {
    revisions: revisions || {},
    capabilities: nextCapabilities || []
  };
  capabilities = snapshot.capabilities;
  const bind = value => {
    if (!value || typeof value !== 'object') return;
    snapshots.set(value, snapshot);
    Object.values(value).forEach(bind);
  };
  bind(data);
  return data;
}
export function unpackWaiseSnapshot(body) {
  return body?.waise_snapshot_v1 ? bindWaiseSnapshot(body.data, body.revisions, body.capabilities) : body;
}
export function waiseCommandAvailable(type, guarded = false) {
  return supportsWaiseCommand(capabilities, type, guarded ? 'rev1:required' : null);
}
export function prepareWaiseCloudMutation(url, {
  method = 'POST',
  body,
  source
} = {}) {
  const mapped = mapWaiseHttpMutationToCommand({
    method,
    path: url,
    body: body || {}
  });
  if (!mapped) throw new Error("Cette action n'est pas disponible depuis le cloud.");
  const resource = waiseRevisionResource(mapped.commandType, mapped.payload);
  const revision = resource ? snapshots.get(source)?.revisions?.[resource] : null;
  if (resource && !revision) throw new Error('Actualisez la fiche avant de confirmer cette action.');
  if (!supportsWaiseCommand(capabilities, mapped.commandType, revision)) throw new Error('Le serveur local doit être mis à jour avant cette action.');
  if (body?._waise_packaging && !capabilities.includes('waise_stock_bundle_v1')) throw new Error('Le serveur local doit être mis à jour avant cette action.');
  return {
    body,
    headers: revision ? {
      'If-Match': revision
    } : {}
  };
}
export function waisePendingMutation(url, {
  method,
  body,
  headers
}, principal) {
  const identity = JSON.stringify([principal, method, url, body && Object.fromEntries(Object.entries(body).filter(([key]) => !['client_request_id', 'command_uuid'].includes(key)))]);
  const key = `moo_waise_pending:${encodeURIComponent(JSON.stringify([principal, method, url]))}`;
  let pending = JSON.parse(localStorage.getItem(key) || 'null');
  if (pending && (!pending.requestId || typeof pending.identity !== 'string')) throw new Error('Une demande précédente doit être vérifiée avant de recommencer.');
  if (!pending) {
    pending = {
      identity,
      requestId: window.crypto?.randomUUID?.() || createDraftClientLineId(),
      body,
      headers
    };
    // Store BEFORE sending: no additive write without a durable retry identity.
    localStorage.setItem(key, JSON.stringify(pending));
  }
  return {
    pending,
    differentIntent: pending.identity !== identity,
    store: () => localStorage.setItem(key, JSON.stringify(pending)),
    clear: () => localStorage.removeItem(key)
  };
}
